// extracted by mini-css-extract-plugin
module.exports = {"header":"product-header_header__Q5RHL"};